<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="4 4 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 4c9.4 0 16 6.3 16 14.5S29.4 33 20 33c-1.9 0-3.7-.3-5.4-.8L7 36l1.6-6.6C5.7 26.8 4 23 4 18.5 4 10.3 10.6 4 20 4z"
      fill="#2357C6"
    />
    <path d="M21.8 10.5 14.5 20.2h5.3l-1.6 7.8 7.3-9.7h-5.3z" fill="#FFFFFF" />
  </svg>
</template>
